var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "banner",
      staticClass: "bili-banner",
      style: _vm.animatedBannerShow
        ? ""
        : _vm.bannerImg
        ? `background-image: url(${_vm.bannerImg})`
        : "",
    },
    [
      _vm.animatedBannerEnabled
        ? _c("AnimatedBanner", {
            attrs: { config: _vm.animatedBannerConfig },
            on: { change: (v) => (_vm.animatedBannerShow = v) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "taperLine", staticClass: "taper-line" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }